module.exports = __webpack_public_path__ + "ca50c88d9ae185c526aa7ded7ac28f16.pdf";